import { createContext, useContext } from 'react'

import { type AssessmentMode } from './ag-grid-assessment/config/modes'

interface AssessmentContextType {
  isOpen: boolean
  setIsOpen: (open: boolean) => void
  assessmentId: string
  setAssessmentId: (id: string) => void
  companyId: string
  setCompanyId: (id: string) => void
  openDeleteModal: (props: { companyId: string; ongoingAssessmentId: string }) => void
  startingAssessmentId: string | null
  setStartingAssessmentId: (id: string | null) => void
  mode: AssessmentMode
}

export const AssessmentContext = createContext<AssessmentContextType | undefined>(undefined)

export const useAssessmentCtx = () => {
  const context = useContext(AssessmentContext)
  if (context === undefined) {
    throw new Error('useAssessmentCtx must be used within an AssessmentProvider')
  }
  return context
}
